import { Component } from '@angular/core';
import { ReactPageComponent } from '../../../../common';
import { IncashPage } from './page';

@Component({
  selector: 'app-page-incash',
  template: '<div class="react-page" #container></div>'
})
export class PageIncashComponent extends ReactPageComponent {
  get Component(){
    return IncashPage;
  }
}
